import { Grid, Card, CardContent } from "@material-ui/core";
import React from "react";
import { Helmet } from "react-helmet";
import Avatar from "@material-ui/core/Avatar";
import "./testimonial.css";
import TestimonialSlider from "./testimonialSlider";
const Testimonial = () => {
  return (
    <>
      <Helmet>
        <script
          src="https://kit.fontawesome.com/64d58efce2.js"
          crossorigin="anonymous"
        ></script>
      </Helmet>
      <Grid container className={"testimonialContainer"} id="testimonial">
        <Grid item md={4} xs={12} className={"testimonialTexts"}>
          <h1 className="serviceTitle">Testimonials</h1>
          <h1 className={"testimonialTitle"}>What Our Clients Says</h1>
          <h1 className={"feedbackTitle"}>Feedback</h1>
        </Grid>
        <Grid item xs={12} md={8}>
          <TestimonialSlider />
        </Grid>
      </Grid>
    </>
  );
};

export default Testimonial;
